// extracted by mini-css-extract-plugin
export default {"statutory-component":"EditCompany_statutory-component__mInV8","modal-header":"EditCompany_modal-header__DGqlZ","modal-header-filter":"EditCompany_modal-header-filter__dJS3b"};